import React from "react";
import PropTypes from "prop-types";
import { XeroClient, ZatcaClient } from "services";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { compose, withProps } from "recompose";

const withListData = compose(
  withProps((parentProps) => ({ parentProps })),
  withOrganisationContextConsumer,
  (BaseComponent) =>
    class extends React.Component {
      static propTypes = {
        // item refers to list of invoices
        item: PropTypes.arrayOf(
          PropTypes.shape({
            Contact: PropTypes.shape({
              ContactID: PropTypes.string.isRequired,
            }).isRequired,
            Type: PropTypes.string.isRequired,
            InvoiceID: PropTypes.string,
            CreditNoteID: PropTypes.string,
          })
        ).isRequired,
        contactID: PropTypes.string,
        fetchOrganisation: PropTypes.func.isRequired,
        fetchTaxRates: PropTypes.func.isRequired,
        fetchSettings: PropTypes.func.isRequired,
      };

      state = {
        item: [], //list of invoices
        qrCodes: [],
        contact: {},
        organisation: {},
        taxRates: {},
        settings: {},
      };


      componentDidMount = async () => {
        let {
          item = [], // list
          fetchOrganisation,
          fetchTaxRates,
          fetchSettings,
        } = this.props;

        let zatcaApp = undefined

        if (typeof (item) === "object") {
          zatcaApp = item.zatcaApp
          item = Object.entries(item)
            .filter(([key]) => !isNaN(key)) // only keep numeric keys
            .map(([, value]) => value);
        }
        zatcaApp = zatcaApp || item[0]?.zatcaApp

        if (item.length === 0) {
          Promise.all([
            fetchOrganisation(),
            fetchTaxRates(),
            fetchSettings(),
          ]).then(([organisation, taxRates, settings]) => {
            this.setState({
              item,
              qrCodes: [],
              contacts: [],
              organisation,
              taxRates,
              settings,
            });
          });
          return;
        }

        const xero = XeroClient();
        const zatca = ZatcaClient();

        const fallback_qr_codes = (ids) => {
          return xero.post(`${endpoint}/generate_qrcode_in_list`, {
            ids,
          }).then(response => {
            return response?.data?.qr_codes;
          }).catch((err) => {
            console.error(err);
            return null;
          });
        }

        const { t } = this.props

        let itemKey = 'InvoiceID';
        let endpoint = 'invoices';


        if (item[0]?.Type === "ACCRECCREDIT") {
          itemKey = 'CreditNoteID'
          endpoint = 'creditnotes'
        }
        if (item[0]?.Type === "ACCPAYCREDIT") {
          itemKey = 'CreditNoteID'
          endpoint = 'creditnotes'
        }
        if (item[0]?.Type === "PURCHASEORDER") {
          itemKey = 'PurchaseOrderID'
          endpoint = 'purchaseorders'
        }

        let ids = item?.map(obj => {
          return obj[itemKey]
        });

        let qrCodeResult = []


        if ((item[0]?.Type === "ACCREC" || item[0]?.Type === "ACCRECCREDIT") && item) {
          qrCodeResult = fallback_qr_codes(ids)
        }

        const uniqueContactIDs = [
          ...new Set(
            item
              .map((invoice) => invoice.Contact?.ContactID)
          )
        ];

        let contacts = await Promise.all(uniqueContactIDs.map(async (contactID) => {
          try {
            return await xero.get(`contacts/${contactID}`).get("data");
          } catch (error) {
            console.error(error);
          }
        }));


        Promise.all([
          qrCodeResult,
          fetchOrganisation(),
          fetchTaxRates(),
          fetchSettings(),
        ])
          .then((results) => {

            const qrCodesResp = results[0];
            const organisation = results[1];
            const taxRates = results[2];
            const settings = results[3];

            const qrCodes = item?.map((item) => {
              return qrCodesResp[item[itemKey]]
            })
            this.setState({
              item,
              qrCodes,
              contacts,
              organisation,
              taxRates,
              settings,
            });
          });
      };

      render = () => {
        const { item } = this.state;
        return item.length > 0 ? (
          <BaseComponent {...this.props.parentProps} {...this.state} />
        ) : null;
      };
    }
);

export default withListData;
